import api from './api';

export const blogService = {
  // Get all posts (public) with pagination
  async getPosts(params = {}) {
    try {
      const response = await api.get('/blog/posts', { params });
      // Return the full response to access pagination metadata
      return response.data;
    } catch (error) {
      console.error('Error fetching posts:', error);
      throw error;
    }
  },

  // Get all posts (admin - includes drafts)
  async getAdminPosts(params = {}) {
    try {
      // For now, use public endpoint with large limit since we don't have admin endpoint yet
      const response = await api.get('/blog/posts', { params: { ...params, per_page: 100 } });
      // Return just the data array for admin context
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error fetching admin posts:', error);
      throw error;
    }
  },

  // Get single post (public)
  async getPost(slug) {
    try {
      const response = await api.get(`/blog/posts/${slug}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching post:', error);
      throw error;
    }
  },

  // Get single post by ID (admin)
  async getPostById(id) {
    try {
      const response = await api.get(`/blog/admin/posts/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching post by ID:', error);
      throw error;
    }
  },

  // Create post (admin)
  async createPost(postData) {
    try {
      const config = postData instanceof FormData
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : {};
      const response = await api.post('/blog/admin/posts', postData, config);
      return response.data;
    } catch (error) {
      console.error('Error creating post:', error);
      throw error;
    }
  },

  // Update post (admin)
  async updatePost(id, postData) {
    try {
      // Laravel doesn't handle PUT with FormData well, use POST with _method
      if (postData instanceof FormData) {
        postData.append('_method', 'PUT');
        const response = await api.post(`/blog/admin/posts/${id}`, postData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
      } else {
        const response = await api.put(`/blog/admin/posts/${id}`, postData);
        return response.data;
      }
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  },

  // Delete post (admin)
  async deletePost(id) {
    try {
      const response = await api.delete(`/blog/admin/posts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting post:', error);
      throw error;
    }
  },

  // Upload image (admin)
  async uploadImage(formData) {
    try {
      const response = await api.post('/blog/admin/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  },

  // Get all categories (public)
  async getCategories() {
    try {
      const response = await api.get('/blog/categories');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get single category (public)
  async getCategory(id) {
    try {
      const response = await api.get(`/blog/categories/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching category:', error);
      throw error;
    }
  },

  // Create category (admin)
  async createCategory(categoryData) {
    try {
      const response = await api.post('/blog/admin/categories', categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category (admin)
  async updateCategory(id, categoryData) {
    try {
      const response = await api.put(`/blog/admin/categories/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  // Delete category (admin)
  async deleteCategory(id) {
    try {
      const response = await api.delete(`/blog/admin/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  }
};

export default blogService;
